import React, { PureComponent, createElement, Fragment } from 'react';
import { message, Dropdown, Menu, Button, Icon, Modal, Form, Input, Radio } from 'antd';
import { connect } from 'react-redux';
import { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';

import { errorHandle } from '../../services';
import { UploadButton } from '../upload-button';
import { ProductInfoExportButton } from '../product-info-export-button';
import { FormComponentProps } from 'antd/es/form';
import lodash from 'lodash';
import './index.less';
const { TextArea } = Input;

const api = services.api;

export interface ProductGoodsViewProps {
    click: () => void;
    form: FormComponentProps['form'];
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

export interface IState {
    selectedKeys: any;
    visible: boolean;
    black_remark: string;
    visibleClear: boolean;
    clearType: boolean;
    productModal: {
        visible: boolean;
        type: string;
    };
}

// 商品经营管理
class productGoodsView extends PureComponent<ProductGoodsViewProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedKeys: [],
            visible: false,
            black_remark: '',
            visibleClear: false,
            clearType: true,
            productModal: { visible: false, type: 'HIDE' },
        };
        this.onAdd = this.onAdd.bind(this);
        this.putShelf = this.putShelf.bind(this);
        this.offShelf = this.offShelf.bind(this);
        this.onDeleteBatch = this.onDeleteBatch.bind(this);
        // this.uploadBlacklist = this.uploadBlacklist.bind(this);
        this.onDeleteAll = this.onDeleteAll.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleOk = (e?: any) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.visible) {
                    const { entity } = this.props;
                    const { selectedKeys } = this.state;
                    let copyselect = selectedKeys.join(',');
                    api.get(
                        {
                            sku_ids: copyselect,
                            black_remark: values.black_remark,
                            is_style: values.is_style,
                        },
                        {
                            apiPath: `/products/add_black`,
                        }
                    )
                        .then((res: any) => {
                            res.data
                                ? message.success('加入黑名单成功')
                                : message.info('已在黑名单中');
                            entity.search({
                                ...entity.params,
                                ...entity.filters,
                            });
                        })
                        .catch(errorHandle);
                } else {
                }
                this.setState({
                    visible: false,
                });
                // 列表数据刷新
                this.props.entity.search({
                    ...this.props.entity.params,
                    ...this.props.entity.filters,
                });
            } else {
                message.error('请填写完整表单再提交');
            }
        });
    };

    handleCancel = () => {
        this.props.form.resetFields();
        this.setState({ visible: false });
    };

    onAdd() {
        this.props.form.resetFields();
        const { selectedKeys } = this.state;
        if (selectedKeys.length === 0) {
            message.warning('请至少选择一项');
        } else {
            this.setState({ visible: true });
            if (this.state.visible) {
                this.handleOk();
            }
        }
    }

    onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };
    // 批量上架
    putShelf() {
        const { entity } = this.props;
        const { selectedKeys } = this.state;
        if (selectedKeys.length === 0) {
            message.warning('请至少选择一项');
        } else {
            let copyselect = selectedKeys.join(',');
            api.get(
                { sku_ids: copyselect },
                {
                    apiPath: '/products/update_status/SALES',
                }
            )
                .then(() => {
                    message.success('批量上架成功');
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }

    // 批量下架
    offShelf() {
        const { entity } = this.props;
        const { selectedKeys } = this.state;
        if (selectedKeys.length === 0) {
            message.warning('请至少选择一项');
        } else {
            let copyselect = selectedKeys.join(',');
            api.get({ sku_ids: copyselect }, { apiPath: '/products/update_status/NOT_SALES' })
                .then(() => {
                    message.success('批量下架成功');
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }

    onDeleteBatch() {
        const { entity } = this.props;
        const { selectedKeys, clearType } = this.state;
        if (selectedKeys.length === 0) {
            message.warning('请至少选择一项');
            this.setState({ visibleClear: false });
        } else {
            let copyselect = selectedKeys.join(',');
            api.get({ is_style: clearType }, { apiPath: `/products/remove_black/${copyselect}` })
                .then(() => {
                    message.success('移出黑名单成功');
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle)
                .finally(() => {
                    this.setState({
                        visibleClear: false,
                    });
                });
        }
    }

    onDeleteAll() {
        const {
            entity: {
                filters,
                paging: { page, perPage },
            },
        } = this.props;

        const params = {
            page,
            perPage,
            ...filters,
        };
        api.get(params, { apiPath: `/products/skuBlackList/export` })
            .then(() => {
                message.success('导出成功，请到 报表管理 - 报表导出管理 中查看');
            })
            .catch(errorHandle);
    }

    onChangeType = (e) => {
        this.setState({ clearType: e?.target?.value });
    };

    renderTable() {
        const { entity, componentId } = this.props;
        const tableProps = {
            entity,
            componentId: componentId + '-Table',
            component: 'DataTable',
            switchRefresh: true,
            loadFirstPage: true,
            rowSelection: {
                onChange: (selectedKeys: string[]) => {
                    this.setState({
                        selectedKeys,
                    });
                },
            },
            // dataSource: entity.result,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: { x: true },
            columns: [
                {
                    property: 'id',
                    modifiable: false,
                    fixed: 'left',
                },
                {
                    property: 'sku',
                    modifiable: false,
                    width: 170,
                    fixed: 'left',
                },
                {
                    property: 'spu',
                    modifiable: false,
                    width: 170,
                },
                {
                    property: 'pzgPic',
                    width: 100,
                    modifiable: false,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'middlePic',
                    width: 100,
                    modifiable: false,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'name',
                    modifiable: false,
                    width: 220,
                },
                {
                    property: 'styleCode',
                    modifiable: false,
                    width: 120,
                },
                {
                    property: 'salesTags',
                    modifiable: false,
                    width: 120,
                },
                {
                    property: 'blackFlag',
                    width: 120,
                    modifiable: false,
                    displayConfig: {
                        statusConfig: {
                            1: {
                                text: '是',
                                status: 'success',
                            },
                            0: {
                                text: '否',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'blackRemark',
                    modifiable: false,
                    width: 120,
                },
                {
                    property: 'ecStock',
                    modifiable: false,
                },
                {
                    property: 'totalStock',
                    modifiable: false,
                },
                {
                    property: 'ecAvailableStock',
                    modifiable: false,
                },
                {
                    property: 'availableStock',
                    modifiable: false,
                },
                {
                    property: 'saleStatus',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            SALES: {
                                text: '上架',
                                status: 'success',
                            },
                            NOT_SALES: {
                                text: '下架',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'supportAppointment',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            SUPPORT: {
                                text: '支持',
                                status: 'success',
                            },
                            NOT_SUPPORT: {
                                text: '不支持',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'searchType',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            '0': {
                                text: '可搜索',
                                status: 'success',
                            },
                            '1': {
                                text: '隐藏',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'isTopping',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            SUPPORT: {
                                text: '是',
                                status: 'success',
                            },
                            NOT_SUPPORT: {
                                text: '否',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'supportPreSales',
                    width: 120,
                    modifiable: false,
                    displayConfig: {
                        statusConfig: {
                            SUPPORT: {
                                text: '支持',
                                status: 'success',
                            },
                            NOT_SUPPORT: {
                                text: '不支持',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'preStartTime',
                    modifiable: false,
                },
                {
                    property: 'preEndTime',
                    modifiable: false,
                },
                {
                    property: 'preHotStartTime',
                    modifiable: false,
                },
                {
                    property: 'preHotEndTime',
                    modifiable: false,
                },
                {
                    property: 'preSendDay',
                    modifiable: false,
                },
                // {
                //     property: 'supportCustomerMade',
                // },
                {
                    property: 'price',
                    modifiable: false,
                },
            ],
            actionColumn: {
                title: '操作',
                width: 200,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'link',
                        text: '查看',
                        path: '/product/goods/{{row.id}}',
                    },
                    {
                        type: 'component',
                        component: 'PreviewProductBtn',
                    },
                    {
                        type: 'component',
                        component: 'QrCodeBtn',
                    },
                    {
                        text: '编辑',
                        type: 'modify',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        text: '保存',
                        type: 'modifyConfirm',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        text: '取消',
                        type: 'modifyCancel',
                        config: {
                            type: 'link',
                        },
                    },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    downloadMould(url: string) {
        services.api.download({}, { apiPath: url }).catch((e: any) => errorHandle(e));
    }

    /**
     * @param type 0:可搜索 1:隐藏 3:模板下载
     */
    handleSearchProduct = (type: string) => {
        const { selectedKeys } = this.state;
        if (type === '0' || type === '1') {
            if (selectedKeys.length === 0) return message.warning('请至少选择一项');

            this.setState({
                productModal: { visible: true, type: type === '1' ? 'HIDE' : 'SHOW' },
            });
        } else {
            this.downloadMould('/templates/UPDATE_PRODUCT_HIDDEN');
        }
    };

    /**
     * 设置商品是否可搜索
     * @param type 0:确定 1:取消
     */
    handleClickProductModal = (type: string) => {
        const { selectedKeys: sku_id_list, productModal: _productModal } = this.state;
        const productModal = { ..._productModal, visible: false };
        if (type === '0') {
            const search_type = _productModal.type === 'HIDE' ? 1 : 0;
            const { entity } = this.props;
            api.put(
                { search_type, sku_id_list },
                { apiPath: '/products/updateProductHidden' }
            ).then(
                () => {
                    message.success('设置成功');
                    entity.search({ ...entity.params, ...entity.filters });
                    this.setState({ productModal });
                },
                (e) => errorHandle(e)
            );
        } else {
            this.setState({ productModal });
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { selectedKeys, productModal } = this.state;
        // 批量上下架
        const upAndDownMenu = (
            <Menu>
                <Menu.Item key="1">
                    <Button
                        type="link"
                        onClick={() => {
                            this.putShelf();
                        }}
                    >
                        按勾选批量上架
                    </Button>
                </Menu.Item>
                <Menu.Item key="2">
                    <Button
                        type="link"
                        onClick={() => {
                            this.offShelf();
                        }}
                    >
                        按勾选批量下架
                    </Button>
                </Menu.Item>
                <Menu.Item key="3">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/UPDATE_SALES');
                        }}
                    >
                        批量上下架模板
                    </Button>
                </Menu.Item>
                <Menu.Item key="4">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/UPDATE_SALES"
                        buttons={{ text: '批量修改上下架', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
            </Menu>
        );

        // 预售
        const presaleMenu = (
            <Menu>
                <Menu.Item key="1">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/UPDATE_PRE_SALE_BULK"
                        buttons={{ text: '批量预售设置', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={116}
                    />
                </Menu.Item>
                <Menu.Item key="2">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/UPDATE_PRE_SALE_BULK');
                        }}
                    >
                        批量预售模版
                    </Button>
                </Menu.Item>
            </Menu>
        );

        // 黑名单
        const blacklistMenu = (
            <Menu>
                <Menu.Item key="1">
                    <Button
                        type="link"
                        onClick={() => {
                            this.onAdd();
                        }}
                    >
                        按勾选加入黑名单
                    </Button>
                </Menu.Item>
                <Menu.Item key="2">
                    <Button
                        type="link"
                        onClick={() => {
                            if (selectedKeys.length === 0) {
                                message.warning('请至少选择一项');
                                return;
                            }
                            this.setState({ clearType: true, visibleClear: true });
                        }}
                    >
                        按勾选移除黑名单
                    </Button>
                </Menu.Item>
                <Menu.Item key="3">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/IMPORT_SKU_BLACK_LIST_V2');
                        }}
                    >
                        黑名单模版下载
                    </Button>
                </Menu.Item>
                <Menu.Item key="4">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/ADD_BLACK_LIST_V2"
                        buttons={{ text: '批量上传黑名单', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
            </Menu>
        );

        // 商品搜索设置
        const productSearchMenu = (
            <Menu>
                <Menu.Item key="1">
                    <Button type="link" onClick={() => this.handleSearchProduct('1')}>
                        按勾选设为隐藏
                    </Button>
                </Menu.Item>
                <Menu.Item key="0">
                    <Button type="link" onClick={() => this.handleSearchProduct('0')}>
                        按勾选设为可搜索
                    </Button>
                </Menu.Item>
                <Menu.Item key="3">
                    <Button type="link" onClick={() => this.handleSearchProduct('3')}>
                        批量设置-模板下载
                    </Button>
                </Menu.Item>
                <Menu.Item key="4">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/UPDATE_PRODUCT_HIDDEN"
                        buttons={{ text: '批量设置-上传', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
            </Menu>
        );

        return (
            <>
                <Fragment>
                    <div className="optionBox">
                        <Dropdown overlay={upAndDownMenu}>
                            <Button type="primary">
                                批量修改上下架 <Icon type="down" />
                            </Button>
                        </Dropdown>
                        <Dropdown overlay={blacklistMenu}>
                            <Button type="primary">
                                批量操作黑名单 <Icon type="down" />
                            </Button>
                        </Dropdown>
                        <Dropdown overlay={presaleMenu}>
                            <Button type="primary">
                                批量预售设置 <Icon type="down" />
                            </Button>
                        </Dropdown>
                        <Dropdown overlay={productSearchMenu}>
                            <Button type="primary">
                                商品搜索设置 <Icon type="down" />
                            </Button>
                        </Dropdown>

                        <ProductInfoExportButton
                            text="商品资料导出"
                            source={{ apiPath: '/products/export' }}
                            entity={this.props.entity}
                        />
                    </div>
                    {this.renderTable()}
                </Fragment>
                <Modal
                    title="加入黑名单"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    okText={'保存'}
                >
                    <Form layout="vertical">
                        <Form.Item label="加入方式">
                            {getFieldDecorator('is_style', {
                                rules: [{ required: true, message: '请选择加入方式' }],
                                initialValue: true,
                            })(
                                <Radio.Group>
                                    <Radio value={true}>按同款加入黑名单</Radio>
                                    <Radio value={false}>按所选sku加入黑名单</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>
                        <Form.Item label="黑名单备注">
                            {getFieldDecorator('black_remark', {
                                rules: [{ required: true, message: '请输入黑名单备注' }],
                            })(
                                <TextArea
                                    rows={4}
                                    maxLength={300}
                                    placeholder="最多输入300个字符！！"
                                />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title="移出黑名单"
                    visible={this.state.visibleClear}
                    onOk={this.onDeleteBatch}
                    onCancel={() => this.setState({ visibleClear: false })}
                    okText={'确定'}
                >
                    <div className="clearBox">
                        <div className="clearBoxTitle">确认移出黑名单?</div>
                        <div className="clearValue">
                            已选{selectedKeys?.length}条数据，移出黑名单后，黑名单备注被清空
                        </div>
                        <div className="clearLabel">移出方式</div>
                        <Radio.Group onChange={this.onChangeType} value={this.state.clearType}>
                            <Radio value={true}>按同款移出黑名单</Radio>
                            <Radio value={false}>按所选sku移出黑名单</Radio>
                        </Radio.Group>
                    </div>
                </Modal>

                <Modal
                    title={`商品搜索设为${productModal.type === 'HIDE' ? '隐藏' : '可搜索'}`}
                    visible={productModal.visible}
                    onOk={() => this.handleClickProductModal('0')}
                    onCancel={() => this.handleClickProductModal('1')}
                >
                    <p>确认将商品搜索设为{productModal.type === 'HIDE' ? '隐藏' : '可搜索'}?</p>
                    <p>已选{selectedKeys.length || 0}条数据。</p>
                    <p>
                        商品将{productModal.type === 'HIDE' ? '不会' : '会'}
                        出现在品真阁小程序的搜索结果中。
                    </p>
                </Modal>
            </>
        );
    }
}

// export const ProductGoodsView = connect()(productGoodsView);
export const ProductGoodsView = Form.create()(productGoodsView);
